import React from 'react';
import PropTypes from 'prop-types';

const OrderCardImage = ({item, hideDetails}) => {
  return (
    <div className={"fullwidth-card-image-container"}>
        <img
            src={item.object_image}
            className={`hidden fullwidth-card-image ${(hideDetails) && "blur"}`}
            alt={item.object_title}
          />
      </div>
  );
};

OrderCardImage.propTypes = {
    item: PropTypes.object,
    hideDetails: PropTypes.bool,
};

export default OrderCardImage;